class FuelType{

    public id: string = ""
    public name : string = ""
    public code : string = ""
    public lcv : number = 0
    public co2eqWtT : number = 0

    //diccionario para los cfs, que van a ser siempre CO2, CH4 y N2O
    public cfs : {[key: string]: number} = {}
    public cslip : number = 0
    public rwd : number = 0

    public for_cii : boolean = false
    public cii_cf : number = 0
    
}

export default FuelType